import PageBox from "PFComponents/box/page_box";
import { Button } from "PFComponents/button";
import ButtonLink from "PFComponents/button/button_link";
import DataTable from "PFComponents/data_table/data_table";
import SimplePagination from "PFComponents/pagination/simple_pagination";
import { ApiRoute } from "PFCore/utilities/routes";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import css from "./allowed_domains_list.module.scss";

const AllowedDomainsListPage = ({ allowedDomains, fetchAllowedDomains }) => {
  const { t } = useTranslation("admin");
  const history = useHistory();
  const [page, setPage] = useState(1);
  const renderActions = (item) => (
    <div className={css.buttonWrapper}>
      <ButtonLink kind="secondary" small href={`/admin/allowed_domains/${item.id}/edit`}>
        {t("translation:edit")}
      </ButtonLink>
      <Button
        kind="danger"
        small
        onClick={() => {
          if (confirm(t("sureToDelete", { key: item.domain }))) {
            $.ajax({
              url: ApiRoute(`/api/admin/allowed_domains/${item.id}`),
              method: "DELETE",
              api_version: 1
            }).then(() => fetchAllowedDomains(page));
          }
        }}
      >
        {t("translation:remove")}
      </Button>
    </div>
  );

  const cellRenderer = (attribute) => <span>{attribute}</span>;

  return (
    <div className={css.wrapper}>
      <div className={css.header}>
        <h1>{t("allowedDomains.title")}</h1>
        <Button onClick={() => history.push(`/admin/allowed_domains/new`, { trigger: true })}>
          {t("allowedDomains.new")}
        </Button>
      </div>
      <PageBox>
        {allowedDomains.meta.total > 0 ? (
          <DataTable
            style={{ whiteSpace: "nowrap" }}
            columns={[
              {
                headerName: t("allowedDomains.columns.name"),
                renderCell: (data) => cellRenderer(data.domain)
              },
              {
                headerName: t("allowedDomains.columns.obligatorySignin"),
                renderCell: (data) => cellRenderer(data.obligatory_signin)
              },
              {
                headerName: t("allowedDomains.columns.actions"),
                renderCell: (data) => renderActions(data),
                narrow: true
              }
            ]}
            data={allowedDomains.entries}
          />
        ) : (
          <div style={{ fontWeight: "bold", display: "flex", justifyContent: "center" }}>
            {t("allowedDomains.notFound")}
          </div>
        )}
      </PageBox>
      <div style={{ marginTop: "30px" }}>
        <SimplePagination
          currentPage={allowedDomains?.meta?.page}
          totalPages={allowedDomains?.meta?.totalPages}
          handleClick={(page) => {
            setPage(page);
            fetchAllowedDomains(page);
          }}
        />
      </div>
    </div>
  );
};

AllowedDomainsListPage.propTypes = {
  allowedDomains: PropTypes.shape({
    entries: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        domain: PropTypes.string,
        obligatory_signin: PropTypes.string
      })
    ).isRequired,
    meta: PropTypes.shape({
      total: PropTypes.number,
      totalPages: PropTypes.number,
      page: PropTypes.number
    })
  }),
  fetchAllowedDomains: PropTypes.func
};

export default AllowedDomainsListPage;
